import React from "react";

// BREAK POINTS
// 375 - 671: Mobile
// 672 - 1055: Tablet
// 1056 - 1920: Desktop
// 1920 & above: Extra Large Desktop

export const deviceWidthBreakpoints = {
  MOBILE_MAX: 671,
  TABLET_MAX: 1055,
  LAPTOP_MAX: 1920
};

export default function useWindowSize() {
  const [windowSize, setWindowSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  function changeWindowSize() {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  }

  React.useEffect(() => {
    window.addEventListener("resize", changeWindowSize);

    return () => {
      window.removeEventListener("resize", changeWindowSize);
    };
  }, []);

  return windowSize;
}
